<template>
  <div class="toolbar__group toolbar__select-wrapper">
    <select aria-label="heading level" class="toolbar__select" v-model="selected">
      <option value="" disabled selected>Heading</option>
      <option v-for="level in Object.keys(levels)" :key="level" :value="level">
        {{ levels[level] }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'Heading',
  data() {
    return {
      levels: {
        h1: 'Heading 1',
        h2: 'Heading 2',
        h3: 'Heading 3',
        h4: 'Heading 4',
        h5: 'Heading 5',
      },
    };
  },
  computed: {
    selected: {
      get() {
        return this.value || '';
      },
      set(value) {
        this.$emit('heading-change', value);
      },
    },
  },
};
</script>
